import { put, takeLatest, call } from 'redux-saga/effects';
import {
  FETCH_DEFAULT_ASSESSMENTS,
  FETCH_MY_ASSESSMENTS,
  CREATE_ASSESSMENT,
  UPDATE_ASSESSMENT,
  DELETE_ASSESSMENT,
} from './constants';
import {
  fetchDefaultAssessmentsSuccess,
  fetchDefaultAssessmentsError,
  fetchMyAssessmentsSuccess,
  fetchMyAssessmentsError,
  createAssessmentSuccess,
  createAssessmentError,
  updateAssessmentSuccess,
  updateAssessmentError,
  deleteAssessmentSuccess,
  deleteAssessmentError,
} from './actions';
import {
  fetchAssessmentByType,
  fetchMyAssessments as apiFetchMyAssessments,
  createAssessment as apiCreateAssessment,
  updateAssessment as apiUpdateAssessment,
  deleteAssessment as apiDeleteAssessment,
} from '../../services/assessmentApi';

function* fetchDefaultAssessmentsSaga() {
  let full = null;
  let basic = null;
  let lastError = null;

  try {
    full = yield call(fetchAssessmentByType, 'full');
  } catch (err) {
    lastError = err.message || err.body?.error || 'Failed to load Full assessment';
  }
  try {
    basic = yield call(fetchAssessmentByType, 'basic');
  } catch (err) {
    lastError = err.message || err.body?.error || 'Failed to load Basic assessment';
  }

  yield put(fetchDefaultAssessmentsSuccess({ full, basic }));
  if (!full && !basic) {
    yield put(
      fetchDefaultAssessmentsError(lastError || 'Failed to load default assessments')
    );
  }
}

function* fetchMyAssessmentsSaga() {
  try {
    const list = yield call(apiFetchMyAssessments);
    yield put(fetchMyAssessmentsSuccess(list));
  } catch (err) {
    yield put(
      fetchMyAssessmentsError(err.message || err.body?.error || 'Failed to load my assessments')
    );
  }
}

function* createAssessmentSaga({ payload }) {
  try {
    const assessment = yield call(apiCreateAssessment, payload);
    yield put(createAssessmentSuccess(assessment));
  } catch (err) {
    const message =
      err.body?.error || err.message || 'Failed to create assessment';
    yield put(createAssessmentError(message));
  }
}

function* updateAssessmentSaga({ id, payload }) {
  try {
    const assessment = yield call(apiUpdateAssessment, id, payload);
    yield put(updateAssessmentSuccess(assessment));
  } catch (err) {
    const message =
      err.body?.error || err.message || 'Failed to update assessment';
    yield put(updateAssessmentError(message));
  }
}

function* deleteAssessmentSaga({ id }) {
  try {
    yield call(apiDeleteAssessment, id);
    yield put(deleteAssessmentSuccess(id));
  } catch (err) {
    const message =
      err.body?.error || err.message || 'Failed to delete assessment';
    yield put(deleteAssessmentError(message));
  }
}

export default function* adminAssessmentSaga() {
  yield takeLatest(FETCH_DEFAULT_ASSESSMENTS, fetchDefaultAssessmentsSaga);
  yield takeLatest(FETCH_MY_ASSESSMENTS, fetchMyAssessmentsSaga);
  yield takeLatest(CREATE_ASSESSMENT, createAssessmentSaga);
  yield takeLatest(UPDATE_ASSESSMENT, updateAssessmentSaga);
  yield takeLatest(DELETE_ASSESSMENT, deleteAssessmentSaga);
}
